var map = {
	"./101.png": 1643,
	"./102.png": 833,
	"./11.jpg": 1644,
	"./BernhardBreil.png": 1645,
	"./DownloadPDF.png": 832,
	"./DuplicateInvoice.png": 1646,
	"./Excel_40x40.svg": 1647,
	"./IP1.png": 875,
	"./IP2.png": 876,
	"./IP3.png": 877,
	"./IP4.png": 878,
	"./IP5.png": 879,
	"./InputField.svg": 827,
	"./PatientBar.png": 1648,
	"./PatientBed.png": 241,
	"./PatientBed2.png": 1649,
	"./Patientbar2.png": 404,
	"./PrintInvoice.png": 831,
	"./QuestionnareMarketing.jpg": 1650,
	"./Right.svg": 1651,
	"./Word_40x40.svg": 1652,
	"./YehoushuaWestover.png": 1653,
	"./active-horizontal.png": 829,
	"./active-pencil.svg": 870,
	"./active-vertical-old.png": 1654,
	"./active-vertical.png": 828,
	"./activetogle.png": 834,
	"./add.svg": 1655,
	"./afterBg.jpg": 1656,
	"./agedman.png": 1657,
	"./aimedis.png": 1658,
	"./arw1.png": 243,
	"./assign-to.svg": 461,
	"./attatchment.png": 778,
	"./barMenu.png": 565,
	"./barMenu2.png": 1659,
	"./bed.png": 406,
	"./bed2.png": 73,
	"./bed22.png": 1660,
	"./bedColor.png": 873,
	"./bedNumber.png": 468,
	"./bin.svg": 208,
	"./binred.svg": 1661,
	"./bitmap.png": 869,
	"./blood-pressure-sugar.svg": 1662,
	"./bpupr.png": 1663,
	"./calendar2.jpg": 1664,
	"./calender.png": 566,
	"./calender2.png": 1665,
	"./calenderIcon.png": 1666,
	"./calenderIcon2.png": 405,
	"./circleRght.jpg": 1667,
	"./clearSrch.jpg": 1668,
	"./clock.svg": 1669,
	"./closebtn.png": 1670,
	"./closefancy.png": 1671,
	"./clspopup.png": 1672,
	"./colorBar.png": 1673,
	"./condition-diagnosis-family-anamnesis-diary.svg": 1674,
	"./condition.png": 1675,
	"./confirmed-diagnosis.svg": 1676,
	"./content-view-column.svg": 874,
	"./copy2.png": 1677,
	"./copyNew.png": 1678,
	"./copycopy.svg": 1679,
	"./deleteNew.png": 349,
	"./dotBrdr.jpg": 1680,
	"./down2.png": 1681,
	"./downArow.png": 1682,
	"./download-1.svg": 1683,
	"./download2.png": 1684,
	"./downloadIcon.png": 1685,
	"./dr1.jpg": 244,
	"./dr2.jpg": 1686,
	"./emergency-diagnosis.svg": 1687,
	"./eye2.png": 880,
	"./eyeicon.jpg": 1688,
	"./fullLogo.png": 355,
	"./germanMedical.png": 1689,
	"./gp.png": 1690,
	"./greyImg.jpg": 1691,
	"./greyImg.png": 220,
	"./groupicon-black.jpg": 184,
	"./groupicon.jpg": 1692,
	"./h2Logo.jpg": 1693,
	"./hLogo.jpg": 1694,
	"./hospitalIcon.png": 407,
	"./hospitalIcon2.png": 316,
	"./hotel-bed-2.svg": 824,
	"./important-notice.svg": 830,
	"./james.jpg": 1695,
	"./jpg.svg": 1696,
	"./lineGraph.png": 1697,
	"./lineGrph.png": 1698,
	"./lines.png": 1699,
	"./link1.png": 1700,
	"./logo_new.png": 418,
	"./menudocs.jpg": 119,
	"./menudocs2.png": 1701,
	"./moreicon.jpg": 1702,
	"./movePatient.png": 1703,
	"./nav-journal.svg": 1704,
	"./nav-more.svg": 1705,
	"./nav-more2.png": 1706,
	"./nav-my-profile.svg": 1707,
	"./navigation-drawer.svg": 1708,
	"./newEntry.png": 1709,
	"./newdownload.png": 1710,
	"./non-active-horizontal.png": 1711,
	"./note.png": 826,
	"./note1.png": 577,
	"./pain.png": 1712,
	"./paragraph-normal.svg": 777,
	"./pat22.png": 1713,
	"./patient-back.svg": 1714,
	"./patient.png": 1715,
	"./pdf.svg": 1716,
	"./pdfimg.png": 1717,
	"./pencil-1.svg": 110,
	"./pencil.jpg": 1718,
	"./pencil.png": 1719,
	"./person1.jpg": 1720,
	"./plusIcon.jpg": 1721,
	"./plusIcon.png": 278,
	"./plusSymbol.png": 1722,
	"./printer2.png": 1723,
	"./profileActv.png": 1724,
	"./qr-code.svg": 1725,
	"./questionnare.jpg": 1726,
	"./questionnare1.png": 1727,
	"./remove-1.svg": 245,
	"./remove-3.svg": 1728,
	"./rightArrow.png": 170,
	"./rightIcon.png": 467,
	"./rightIcon2.png": 80,
	"./rightTick.png": 776,
	"./rightpng.png": 118,
	"./rightpng2.png": 1729,
	"./room.svg": 353,
	"./room2.svg": 1730,
	"./room22.svg": 872,
	"./roomColor.svg": 1731,
	"./search-entries.svg": 155,
	"./setting.png": 417,
	"./share.svg": 1732,
	"./sort-active.png": 156,
	"./sort.png": 157,
	"./square.png": 416,
	"./statisticsImg.jpg": 1733,
	"./statisticsImg2.png": 1734,
	"./threeDots.png": 276,
	"./threeDots2.png": 279,
	"./threeDots3.png": 1735,
	"./timecheck.svg": 1736,
	"./timeline-view-active.svg": 1737,
	"./upload-file.svg": 1738,
	"./user-clipboard.svg": 1739,
	"./user-group-conversation.svg": 825,
	"./video.png": 1740,
	"./ward.png": 871,
	"./yesinfo.jpg": 1741,
	"./youtube.png": 1742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1642;